import i18next from 'i18next';
import { COMPLIANCE_STATUS_COLORS } from 'appConstants';

const COMPLIANCE_STATUSES = ['valid', 'expiring_soon', 'expired', 'incomplete'];

const translate = key => {
  if (i18next && typeof i18next.t === 'function') {
    return i18next.t(key);
  }
  return key;
};

const transformToComplianceStatusBuckets = data => {
  if (!data) {
    return [];
  }

  return COMPLIANCE_STATUSES.map(status => ({
    legendTitle: translate(`compliance.statuses.${status}`),
    fillColor: COMPLIANCE_STATUS_COLORS[status] || '#757575',
    filterValue: status,
    value: data[status] || 0,
  })).filter(item => item.value > 0);
};

export default transformToComplianceStatusBuckets;
